export const PRODUCTS_FILTER_PARAM_KEY = 'products-filter';
export const PRODUCTS_SEARCH_PARAM_KEY = 'products-search';
export const DEFAULT_CATEGORY_FILTER = 'compliance';
// TODO: Should replace this array when the new product cards API is ready
export const STANDALONE_REDIRECTS = [
  {
    name: 'Small Business Insurance from NEXT',
    url: 'next-insurance'
  },
  {
    name: 'Legal Shield',
    url: 'legal-shield'
  },
  {
    name: 'Business Kit',
    url: 'business-kit'
  },
  {
    name: 'EIN (Employer Identification Number)',
    url: 'ein-creation'
  },
  {
    name: 'Certificate of Good Standing',
    url: 'standard-good-standing'
  },
  {
    name: 'Basic Trademark Search',
    url: 'trademark-search'
  }
];
